import React from 'react';
import { Field, FieldProps } from 'formik';
import { InputBase } from '@brighterion/br-ui';
import { useTranslation } from 'react-i18next';
import { HandleBlur, HandleChange } from './types';

type Props = {
    handleBlur: HandleBlur;
    handleChange: HandleChange;
};

export const FieldDescription = ({ handleBlur, handleChange }: Props) => {
    const { t } = useTranslation();

    return (
        <Field name='merchantDescription'>
            {({ field }: FieldProps) => (
                <InputBase
                    id='merchant-desc'
                    label={t('Description (Optional)')}
                    value={field.value ?? ''}
                    name='merchantDescription'
                    onChange={handleChange}
                    onBlur={handleBlur}
                    size='sm'
                    data-testid='add-merchant-desc-field'
                    allowPan
                />
            )}
        </Field>
    );
};

export default FieldDescription;
